class GoToTop {
    static init() {
        this.html = document.querySelector("html");
        this.footer = document.querySelector(".footer");
        this.cta = document.querySelector(".gotop");
        if (this.cta) {
            this.render(0);
        }
    }

    static render(t) {
        if (this.cta) {
            let htmlTop = this.html.getBoundingClientRect().top;
            let footerTop = this.footer.getBoundingClientRect().top;
            let windowHeight = window.innerHeight;
            let diff = footerTop < windowHeight ? windowHeight - footerTop : 0;

            if (htmlTop < - 200) {
                this.cta.classList.add("gotop--visible")
            } else {
                this.cta.classList.remove("gotop--visible")
            }

            if (this.lastDiff != diff) {
                this.lastDiff = diff;
                this.cta.style.transform = "translateY(-" + diff + "px)";
            }
        }

        requestAnimationFrame(this.render.bind(this));
    }
}

export default GoToTop;


// WEBPACK FOOTER //
// ./src/scripts/components/gototop.js